import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AuthService} from '@gallaghercp/core-frontend';
import {APP_CONFIG} from '../../app.config';
import {ClientService} from '../../services/client.service';

@Component({
    standalone: false,
    selector: 'core-maintenance',
    templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent implements OnInit {
    appName = APP_CONFIG.appName;
    copyright = APP_CONFIG.copyright;

    constructor(
        protected auth: AuthService,
        protected router: Router,
        protected titleService: Title,
        public client: ClientService,
    ) {
    }

    ngOnInit() {
        this.titleService.setTitle('Maintenance | ' + APP_CONFIG.appName);
        this.auth.initialise().subscribe(() => {
            if (this.auth.serviceProvider.status === 'ACTIVE') {
                this.router.navigate(['/']);
            }
        });
    }

}
